import React from 'react';
import { useTranslation } from 'react-i18next';

import { Block, Webform } from '@uncinc/react-drupal-core';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import Logo from '../../implementations/Menu/Logo';
import { APP_OPTIONS } from '../../config/constants';

import './style.scss';

const NewsletterSubscribe = () => {
  const { t } = useTranslation();

  return (
    <div className="NewsletterSubscribe">
      {/* Background image */}
      <Block id={APP_OPTIONS.parameters.footerImageBlockID} />

      <div className="NewsletterSubscribe__gradient" />

      <Container>
        <div className="row">
          <div className="col-12 col-lg-1">
            <Logo />
          </div>
          <div className="col-12 col-md-9 col-lg-5">
            <div className="NewsletterSubscribe__form">
              <h3 className="NewsletterSubscribe__title">{t('footer.newsletter_title')}</h3>
              <p className="NewsletterSubscribe__subtitle">{t('footer.newsletter_subtitle')}</p>
              <Webform scrollToTopAfterSubmit={false} id={APP_OPTIONS.parameters.newsletterID} />
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default NewsletterSubscribe;
